







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Alert extends Vue {
	@Prop()
	type!: string;

	get alertClass(): string {
		return 'alert__inner--' + this.type;
	}
}
